function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.50564 11.2585V5.74338C5.50564 5.32197 5.8485 4.97916 6.26991 4.97916C6.69137 4.97916 7.03418 5.32202 7.03418 5.74338H8.77329C8.77329 4.36301 7.65027 3.23999 6.26986 3.23999C4.88944 3.23999 3.76652 4.36306 3.76652 5.74338V11.2585H0.666992V13.7118H27.3337V11.2585H5.50564V11.2585Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.9707 15.4504V15.8287V18.7691C1.9707 20.8181 3.5168 22.5118 5.50346 22.7476L4.99862 24.1847L6.6395 24.7611L7.33664 22.7767H20.6637L21.3608 24.7611L23.0017 24.1847L22.4969 22.7476C24.4836 22.5118 26.0296 20.818 26.0296 18.7691V15.8287V15.4504H1.9707Z",
  fill: "#D7D6E0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26.6667,
  height: 26.6667,
  fill: "white",
  transform: "translate(0.666992 0.666748)"
})));

var SvgBathroom = function SvgBathroom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBathroom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bathroom.d0e6f495.svg";
export { ForwardRef as ReactComponent };